/**
 * Large scripted construction-site events. Segments expose sockets, the manager arms them.
 * Moving hazards (hazards/) are armed through sockets of CRANE_LOAD_SWING (SEG_09),
 * EXCAVATOR_SWING (SEG_10), FORKLIFT_CROSSING (SEG_11) and SLOW_TRUCK (SEG_03 truck variant);
 * WALL_COLLAPSE drives the collapse set piece.
 */
export const DynamicEventType = {
  ExcavatorSwing: 'EXCAVATOR_SWING',
  ForkliftCrossing: 'FORKLIFT_CROSSING',
  PalletLift: 'PALLET_LIFT',
  CraneLoadSwing: 'CRANE_LOAD_SWING',
  TruckArrival: 'TRUCK_ARRIVAL',
  /** Slow truck coming towards the runner in one lane (SEG_OBSTACLE_TRUCK_40M). */
  SlowTruck: 'SLOW_TRUCK',
  WallCollapse: 'WALL_COLLAPSE',
  PitOpening: 'PIT_OPENING',
  ScaffoldBlock: 'SCAFFOLD_BLOCK',
} as const;

export type DynamicEventType = (typeof DynamicEventType)[keyof typeof DynamicEventType];
